import axios from "../axios/axios";
import { setProjects } from "../store/actions/projectAction";
import { errorDispatcher, setSelectItemLabels } from "../helpers";
import { resetForm, setAction, setEditItem, setIndex, updateFormStatus } from "../store/actions/formAction";
import { appCloseModal, appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { setProjectFormData } from "../helpers/FormDataCreator";
import fileDownload from "js-file-download";
import { DateToString } from "components/Reports/DateFilter";

export const apiGetProjectsExcel = (token, type, selectedIds) => (dispatch, getState) => {
  let url = `projects/excel/export`;
  if (selectedIds && selectedIds.length > 0) {
    url += `?ids=[${selectedIds}]`;
  }
  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_");
      fileDownload(response.data, `projects_${now}.xlsx`);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetProject = (projectId, token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`projects/${projectId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setEditItem(response.data.project));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetProjects = (token, cb) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get("projects", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const projects = setSelectItemLabels(response.data.projects, "id", "title");
      dispatch(setProjects(projects));
      dispatch(appSetLoading(false));
      cb && cb(response);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

export const apiAddProjects = (forms, token, navigate, modalProps) => (dispatch, getState) => {
  dispatch(appSetSendingRequest(true));
  dispatch(setAction("save"));
  apiAddProject(dispatch, forms, token, 0, navigate, modalProps);
};

export const apiAddProject = (dispatch, forms, token, index, navigate, modalProps, errorIndex = null) => {
  const form = forms[index];

  const nextApi = (res) => {
    if (index + 1 < forms.length) {
      apiAddProject(dispatch, forms, token, index + 1, navigate, modalProps, errorIndex);
    } else {
      dispatch(appSetSendingRequest(false));
      if (errorIndex !== null) {
        dispatch(setAction("filling"));
        dispatch(apiSetAlert(forms[errorIndex].errors, "error"));
        dispatch(setIndex(forms[errorIndex].index));
      } else {
        dispatch(apiSetAlert("لیست پروژه ها با موفقیت ثبت شد", "success", !!modalProps));

        if (modalProps) {
          dispatch(appCloseModal());
          dispatch(resetForm());
          if (res) {
            modalProps.onFinish(token, res);
          } else {
            dispatch(modalProps.onFinish(token));
          }
        } else {
          navigate("/projects");
        }
      }
    }
  };

  if (form.status !== "saved") {
    dispatch(setIndex(form.index));
    dispatch(updateFormStatus("saving"));
    const formData = setProjectFormData(form);
    axios
      .post("/projects", formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch(updateFormStatus("saved"));
        nextApi(response?.data?.project);
      })
      .catch((error) => {
        errorIndex = index;
        dispatch(updateFormStatus("error", error?.response?.data?.message));
        nextApi();
      });
  } else {
    nextApi();
  }
};

export const apiDeleteProject = (projectId, token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .delete(`/projects/${projectId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiGetProjects(token));
      dispatch(apiSetAlert(response.data.message, "success"));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiUpdateProject = (projectId, form, token, navigate) => (dispatch, getState) => {
  const formData = setProjectFormData(form);

  dispatch(appSetSendingRequest(true));
  axios
    .put(`projects/${projectId}`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      navigate("/projects");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
